// extracted by mini-css-extract-plugin
export var alignCenter = "_9k-d";
export var bannerShown = "_9k-6";
export var buttonContent = "_9k-0";
export var cardList = "_9k-1";
export var centerContent = "_9k-2";
export var chevron = "_9k-3";
export var closePanelButton = "_9k-k";
export var conversationContextContainer = "_9k-l";
export var conversationDetailContainer = "_9k-4";
export var detailWrapper = "_9k-7";
export var dropdownButton = "_9k-e";
export var dropdownTitle = "_9k-9";
export var fullHeight = "_9k-5";
export var hidden = "_9k-a";
export var icon = "_9k-b";
export var mergeSuggestionWrapper = "_9k-m";
export var panel = "_9k-i";
export var portalButtonsWrapper = "_9k-c";
export var right = "_9k-j";
export var tableSummaryContainer = "_9k-8";
export var tableSummaryHeader = "_9k-g";
export var threeDotsButton = "_9k-f";
export var wide = "_9k-h";